// What the signed-in person may do, as their role carries it. The server
// answers /auth/permissions/me once after sign-in (App.jsx keeps it fresh);
// pages ask `can('whatsapp.delete')` before showing a button the server
// would refuse anyway.
import { useEffect, useState } from 'react';

export const PERMISSIONS_EVENT = 'acuon:permissions-changed';

export function myPermissions() {
  return Array.isArray(window.__acuon_permissions) ? window.__acuon_permissions : null;
}

function isAdmin() {
  try {
    const u = JSON.parse(localStorage.getItem('userData') || '{}');
    return u.role === 'admin' || u.role === 'super_admin';
  } catch {
    return false;
  }
}

// Before the answer arrives an administrator may (they carry everything);
// everyone else waits for the server's word rather than seeing a button
// that will be refused.
export function can(key) {
  const perms = myPermissions();
  if (perms === null) return isAdmin();
  return perms.includes(key);
}

export function setPermissions(list) {
  window.__acuon_permissions = Array.isArray(list) ? list : null;
  window.dispatchEvent(new Event(PERMISSIONS_EVENT));
}

export function usePermissions() {
  const [perms, setPerms] = useState(myPermissions());
  useEffect(() => {
    const onChange = () => setPerms(myPermissions());
    window.addEventListener(PERMISSIONS_EVENT, onChange);
    return () => window.removeEventListener(PERMISSIONS_EVENT, onChange);
  }, []);
  return {
    loaded: perms !== null,
    can: (key) => (perms === null ? isAdmin() : perms.includes(key)),
  };
}
